import { PropsWithChildren, ReactElement } from "react";
import styles from "./Table.module.css";
import { classNames } from "../utils/classNames";
import { TableContext } from "./TableContext";

export interface TableProps {
  variant?: "LARGE" | "IN_CARD" | "IN_CARD_DENSE" | "EDITABLE" | "EDITABLE_DENSE" | "COMPACT";
  hoverable?: boolean;
  withRowBorders?: boolean;
  inline?: boolean;
  containerClassName?: string;
}

export function Table({
  variant = "LARGE",
  hoverable,
  withRowBorders,
  children,
  inline,
  containerClassName,
}: PropsWithChildren<TableProps>): ReactElement {
  const context = {
    editable: variant === "EDITABLE" || variant === "EDITABLE_DENSE",
    compact: variant === "EDITABLE_DENSE" || variant === "IN_CARD_DENSE",
  };
  const element = (
    <TableContext.Provider value={context}>
      <table
        className={classNames(
          !inline && "tw-w-full",
          styles.table,
          styles[variant],
          hoverable && styles.hoverable,
          withRowBorders && styles.withRowBorders,
        )}
      >
        {children}
      </table>
    </TableContext.Provider>
  );
  return inline ? (
    element
  ) : (
    <div className={classNames(styles.container, containerClassName)}>{element}</div>
  );
}
